import React from 'react';

import imageNotFound from '../../assets/img/not-found.svg';

const NotFound = () => {
  return (
    <div className="search__not-found">
      <div className='search__not-found-img'>
        <img src={window.location.host == 'localhost:3000' ? imageNotFound : 'https://os.kaspersky.ru/wp-content/themes/os_theme_new_new/static/media/not-found.7001f19f8a78bc70fad6183d88991842.svg'} />
      </div>
      <div className="search__not-found-title">Ничего не найдено</div>
      <div className="search__not-found-description">К сожалению, по вашему запросу нет результатов. Попробуйте другой запрос.</div>
    </div>
  )
}

export default NotFound;